<template>
  <div>
    <van-button
      :loading="againLoading"
      class="button-active"
      size="small"
      round
      normal
      @click="againFun"
    >再次购买</van-button>
  </div>
</template>
<script>
import http from "@/utils/axios";
import Util from "@/utils/common";
export default {
  props: {
    item: Object,
    goodList: {
      type: Array,
      default: () => {
        return [];
      }, 
      required: true
      //validator: () => {}
    },
    yel: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      againLoading: false,
      count: 0,
      aginRequeryList: []
    };
  },
  methods: {
    //再次购买
    againFun() {
      const { item } = this;
      if (!item || item.IS_GOODS) {
        this.againLoading = true;
        this.goodList.forEach(element => {
          this.doAgainFun({
            count: element.goodsCount,
            goodId: element.goodsId
          });
        });
      } else if (item.isCoupon) {
        Util.jumpToNewPage({
          url: `${location.origin}/h5user/couponDetail?id=${this.goodList[0].contentCouponId}`,
          noTitle: '0'
        });
      } else {
        Util.jumpToNewPage({
          url: `${location.origin}/h5user/couponPackageDetail?id=${this.goodList[0].couponPackageId}`,
          noTitle: '0'
        });
      }
    },
    doAgainFun(pageParam) {
      http({
        url: "item/shoppingCart/add",
        method: "POST",
        parmes: pageParam
      })
        .then(rps => {
          this.count++;
          this.aginRequeryList.push(pageParam.goodId + "");
          this.againLoading = false;
          this.doGoFun();
        })
        .catch(rps => {
          this.count++;
          this.againLoading = false;
          this.doGoFun();
        });
    },
    doGoFun() {
      if (this.count == this.goodList.length) {
        if (this.aginRequeryList.length > 0) {
          Util.buyAgain(this.aginRequeryList.join(","));
        }
        this.againLoading = false;
      }
    }
  },
  created() {
    //console.log(this.goodList);
  },
  components: {},
  computed: {},
};
</script>
<style lang="less" scoped>
.div-btn-a {
  border-radius: 0.5rem;
  color: #333;
  font-size: 0.3rem;
  width: 160px;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  margin: 0 10px;
  border: 1PX solid var(--buttonColor);
  font-weight: 500;
}
.yel {
  background: var(--buttonColor);
  color: var(--textColor);
}
</style>